<template>
  <div id ="detail-page">
  <h1>Detail Product</h1>
   <div v-if= "product.product" class="card card-detail" style="width: 36rem; text-align= center">
    <img class="card-img-top" :src="product.product.imgUrl" alt="product.product.imgUrl">
    <div class="card-body">
     
      <h5 class="card-title">{{product.product.name}} AAAAA</h5>
      <p class="card-text">{{product.product.description}}</p>
      <p class="qrcode-display">
        <img class="text-align : center" :src= "qrCode" alt="">
      </p>
      <p class="card-text">Category : {{product.product.Category.name}}</p>
      <p class="card-text">{{getCurrency(product.product.price)}}</p>
      <p class="card-text">Launching at {{(formattedDate(product.product.createdAt))}}</p>
      <a class="btn btn-danger" @click="cancel">Back to Product List</a>
    </div>
    </div>

  </div>
</template>

<script>
import Swal from 'sweetalert2'

import axios from 'axios'
export default {
    name : "DetailPage",
    data : function(){
      return{
        qrCode : ''
      }
    },
    computed : {
      product(){
        return this.$store.state.product
      }
    },
    methods : {
      getCurrency : function(number){
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(number);
      },
      formattedDate : function(date){
        // return 'asuupdate'
        let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let data = new Date(date)
        return data.toLocaleDateString("en-US", options);
      },
      cancel(){
        this.$router.push({name : "Home"})
      },
      getQR(){
        console.log('masuk functionQR');
        const url = 'https://api.happi.dev/v1/qrcode'
        axios({
          method : 'GET',
          url,
          headers :{
           'x-happi-key' : '249f97W0FlSIDQA2JAYnb5FXuLJRnCTvlRvgzt8bYQ5qBt4Rxt67Xvk0',
          
          },
          params : {
            data : window.location.href,
            width : 128
          }
        })
        .then(response => {
          console.log(response.data.qrcode, 'masuk response qrcode');
          this.qrCode = response.data.qrcode
        })
        .catch(err => {
          console.log(err);
        })
      }
    },
    created() {
      // console.log('ASUUUUUP', this.$route.path);
      let id = this.$route.params.id
      this.$store.commit("DETAIL_PRODUCT", id)
      this.$store.dispatch("detailProduct")
        .then( () => {
          this.getQR()
        })
        .catch(err => {
          console.log(err.response.data.message, 'ASUUP');
          Swal.fire({
            title: 'Dor!',
            text: 'Product Detail Cant Be Found',
            imageUrl: 'https://1.bp.blogspot.com/-cPuiOJ_jdNM/V99MsPZ3FCI/AAAAAAAAAU0/4dM5-pzG-JIYcwjuu-40ph-uXyZKIswpwCLcB/s1600/404-error.jpg',
            imageWidth: 400,
            imageHeight: 200,
            imageAlt: 'Custom image',
          })
          this.$router.push({name : "Home"})
        })
      
      
  },
}
</script>

<style>


img{
  display: block;
  text-align: center;
}

.qrcode-display{
  text-align: center;
  position: relative;
  margin-left: 38%;
}

.card-detail{
  display: flex;
  margin-left: 250px;
  margin-right: 200px;
  
  justify-content: center;
}
</style>